import React, { } from 'react';
import { useDispatch } from 'react-redux';
import { addClassificacao, fetchAllClassificacoesByReino, updateClassificacaoById } from '../../../store/Classificacao/classificacaoSlice';
import { Label } from '@atlaskit/form';
import { Conteudo } from 'view/section/Conteudo/Conteudo';
import * as Yup from 'yup';
import { ClassificacaoCascaderStyled } from '../ClassificacaoCascader/ClassificacaoCascader';
import { Input } from 'antd';
import { Botao, BotaoFlat } from '../Botao/Botao';
import { MensagemErro } from '../Formulario/MensagemErro/MensagemErro';
import { UnidadeSelect } from '../UnidadeSelect/UnidadeSelect';
import { Field, Form, Formik } from 'formik';

interface ClassificacaoFormProps {
  initialValues?: any;
  onSubmit?: () => void;
  onClose?: () => void;
}


const ClassificacaoForm: React.FC<ClassificacaoFormProps> = ({ initialValues, onClose }) => {
  const dispatch = useDispatch();
  const isEditing = !!initialValues.id;


  const validationSchema = Yup.object().shape({
    nome: Yup.string().required('Campo obrigatório'),
    unidadeId: Yup.string().required('Campo obrigatório'),
  });

  return (
    <Conteudo>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          
          (async () => {
            if (isEditing) {
              await dispatch(updateClassificacaoById(values));
            } else {
              await dispatch(addClassificacao(values));
            }
            dispatch(fetchAllClassificacoesByReino());
          })();
          
          if (onClose) {
            onClose();
          }
        }}
      >
        <Form>
          <label htmlFor="paiId">Classificação pai</label>
          <div>
            <ClassificacaoCascaderStyled name="paiId" placeholder="Classificação pai..." />
          </div>

          <label htmlFor="nome">Título</label>
          <Field name="nome" type="text" placeholder="Título da Classificação" as={Input} />
          <MensagemErro name="nome" />

          <Label htmlFor="unidadeId">Unidade associada</Label>
          <UnidadeSelect name="unidadeId" inputId="unidadeId" unidades={[]} />
          <MensagemErro name="unidadeId" />

          <footer>
            <Botao>{isEditing ? "Atualizar" : "Salvar"}</Botao> <BotaoFlat tipo="cancel" onClick={onClose}>Cancelar</BotaoFlat>
          </footer>
        </Form>
      </Formik>
    </Conteudo>

  );
};

export default ClassificacaoForm;

